import * as React from 'react'
import styled, { css } from 'styled-components'

import Icon from '../../ui/Icon/Icon'

import media from '../../../services/generateMediaQueries'

import * as OffersApiService from '../../../services/api/requests/Offers'
import AllIcon from '../../../assets/img/All.png'

let ERROR

const Container = styled.div`
  position: relative;
  height: 3.5rem;
  padding-top: 0.5rem;
  font-size: 1rem;

  display: flex;
  flex-direction: column;
`

const FormContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;

  background: #ffffff;
  border-radius: var(--border-radius-form);

  box-shadow: var(--box-shadow-form);
  padding: 0 1.25rem;

  min-height: 48px;
  max-height: 48px;

  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #ffffff;

  ${() =>
    ERROR &&
    css`
      border-color: var(--color-error);
    `}

  transition: all var(--animation-duration) var(--animation-easing);
`

const Placeholder = styled.p`
  flex: 1;
  color: var(--color-fg-light);
  margin: 0;

  user-select: none;

  ${media.lessThan('small')`
    ${props =>
      props.hasValue &&
      css`
        display: none;
      `}
  `}
`

const Result = styled.div`
  display: flex;
  justify-content: space-between;

  ${media.lessThan('small')`
    flex: 1;
  `}
`

const PickerContainer = styled.div`
  position: absolute;
  width: 850px;

  background: #ffffff;
  box-shadow: var(--box-shadow);
  border-radius: var(--border-radius-form);
  z-index: 2;
  top: 2.5rem;

  display: none;

  padding: 2.5rem;

  ${props => {
    if (props.pickerState) {
      return css`
        display: block;
        top: 4.5rem;

        ${media.lessThan('small')`
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 9999;
        `}
      `
    }

    return null
  }}

  transition: all var(--animation-duration) var(--animation-easing);
`

const CatalogTitle = styled.h3`
  text-transform: uppercase;
  margin: 0;
  margin-bottom: 1.5rem;
`

const CatalogContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;

  margin: 0 -0.75rem;
`

const CatalogItem = styled.div.attrs(props => ({
  style: { backgroundImage: `url('${props.imageUrl}')` },
}))`
  width: 85px;
  height: 85px;
  margin-bottom: 0.5rem;
  border: 1px solid var(--color-fg-lighter);
  border-radius: var(--border-radius-card);
  background-size: 60%;
  background-position: center;
  background-repeat: no-repeat;
  transition: all var(--animation-duration) var(--animation-easing);
`

const CatalogName = styled.p`
  color: var(--color-fg-light);
  font-weight: var(--font-weight-bold);
  margin: 0;
  text-align: center;
  font-size: 0.875rem;
  max-width: 85px;
  transition: all var(--animation-duration) var(--animation-easing);
`

const CatalogItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0.75rem;
  cursor: pointer;

  &:hover {
    ${CatalogItem} {
      border-color: var(--color-primary);
    }

    ${CatalogName} {
      color: var(--color-primary);
    }
  }
`

const DefaultCloseButton = styled.button`
  position: absolute;
  color: var(--color-fg);
  border: 0;
  background-color: transparent;
  top: 2rem;
  right: 2.5rem;
  font-size: 30px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 48px;
  height: 48px;
  padding: 9px;
  border-radius: 100%;
  outline: none;

  display: none;

  ${media.lessThan('small')`
    display: block;
  `}

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`

const StyledIcon = styled(Icon)`
  position: relative;
  top: -4px;
  color: var(--color-primary);
`

const Error = styled.span`
  color: var(--color-error);
  font-size: 0.875rem;

  padding: 0 1.25rem;

  display: none;

  ${() =>
    ERROR &&
    css`
      display: initial;
    `}
`

class CatalogPicker extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      pickerState: false,
      catalog: null,
      selectedCatalog: props.initialCatalogId,
    }

    this.getCatalog()
  }

  getCatalog = async () => {
    try {
      const { data: catalog } = await OffersApiService.getRewardsCatalog()
      const AllCatalog = {
        id: 0,
        name: 'All',
        imageUrl: AllIcon,
      }
      this.setState({
        catalog,
        selectedCatalog: AllCatalog,
      })
    } catch (error) {}
  }

  togglePicker = () => {
    const { pickerState } = this.state

    this.setState({
      pickerState: !pickerState,
    })
  }

  onSelectCatalog = catalog => {
    const { onChange, toggleSearchError } = this.props

    if (onChange) {
      onChange(catalog)
    }

    this.setState({
      selectedCatalog: catalog,
    })
    toggleSearchError(false)
    this.togglePicker()
  }

  render() {
    const { pickerState, catalog, selectedCatalog } = this.state
    const { error, ...props } = this.props

    const AllCatalog = {
      id: 0,
      name: 'All',
      imageUrl: AllIcon,
    }

    ERROR = error

    return (
      <Container {...props}>
        <FormContainer onClick={this.togglePicker}>
          <Placeholder hasValue={!!selectedCatalog}>
            Select Categories
          </Placeholder>
          <Result>
            <span style={{ marginRight: '1rem' }}>
              {selectedCatalog ? selectedCatalog.name : ''}
            </span>
            <span>
              <StyledIcon name="caret" />
            </span>
          </Result>
        </FormContainer>
        <Error>Please select a category</Error>
        <PickerContainer pickerState={pickerState}>
          <DefaultCloseButton onClick={this.togglePicker}>
            <Icon name="x" />
          </DefaultCloseButton>
          <CatalogTitle>Categories</CatalogTitle>
          <CatalogContainer>
            <CatalogItemContainer
              onClick={() => this.onSelectCatalog(AllCatalog)}
            >
              <CatalogItem imageUrl={AllCatalog.imageUrl} />
              <CatalogName>{AllCatalog.name}</CatalogName>
            </CatalogItemContainer>
            {catalog &&
              catalog.map(catalogItem => (
                <CatalogItemContainer
                  key={catalogItem.id}
                  onClick={() => this.onSelectCatalog(catalogItem)}
                >
                  <CatalogItem imageUrl={catalogItem.imageUrl} />
                  <CatalogName>{catalogItem.name}</CatalogName>
                </CatalogItemContainer>
              ))}
          </CatalogContainer>
        </PickerContainer>
      </Container>
    )
  }
}

CatalogPicker.defaultProps = {
  // TODO: specify default props
}

CatalogPicker.propTypes = {
  // TODO: specify prop types
}

export default CatalogPicker
